import { DateField } from "@simplybusiness/mobius";
import type { FocusEvent } from "react";
import type { Range } from "../../../../validation/question/rules/types";
import type { QuestionComponentProps } from "../types";

export const DateInputQuestion = ({
  questionFieldProps,
}: QuestionComponentProps) => {
  // Destructure the questionFieldProps to get the necessary props
  // We don't want to pass an onChange through
  const {
    name,
    validation,
    onBlur,
    value,
    onChange,
    readOnly,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;

  // Find min and max values from the validation value
  let minDate: string | undefined;
  let maxDate: string | undefined;

  if (validation?.type === "range") {
    const { min, max } = validation.value as Range;
    minDate = min as string | undefined;
    maxDate = max as string | undefined;
  }

  const handleBlur = (event: FocusEvent<Element>) => {
    const { value } = event.target as HTMLInputElement;
    onBlur?.({
      ...event,
      target: { name: questionFieldProps.name, value },
    });
  };

  return (
    <DateField
      {...otherProps}
      defaultValue={value as string}
      onBlur={handleBlur}
      min={minDate}
      max={maxDate}
      isReadOnly={!!readOnly}
    />
  );
};
